var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Success',{attrs:{"src":_vm.src}},[_vm._v("Please check "),_c('strong',[_vm._v(_vm._s(_vm.sentTo))]),_vm._v(" for the OnCall Air Finance+ Easy Link and get a decision in seconds.")])}
var staticRenderFns = []

export { render, staticRenderFns }